import { ViewStream } from "spyne";

export class PageHomeSolutionsSection extends ViewStream {
  constructor(props = {}) {
    props.class = "external-section";
    props.id = "home-solutions-section";
    props.template = require("./templates/page-home-solutions-section.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [];
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  onRendered() {}
}
